<div *ngIf="scoutTaskDoc" class="py-2 scout-header d-flex flex-wrap">
    <div>
        Scout&nbsp;-&nbsp;
    </div>
    <div>
        {{scoutTaskDoc.stage}}&nbsp;-&nbsp;
    </div>
    <div role="button" (click)="onShowBuilding()">
        {{scoutTaskDoc.buildingId}}<span *ngIf="scoutPath">&nbsp;-&nbsp;</span>
        <div class="scout-header-subscript">
            <ng-container *ngIf="scoutTaskDoc['buildingDoc']?.commonName; else noBuildingName">{{scoutTaskDoc['buildingDoc']?.commonName}}</ng-container>
            <ng-template #noBuildingName>Building</ng-template>
        </div>
    </div>
    <div *ngIf="scoutPath">
        {{scoutPath.pathNumber||'?'}}<span *ngIf="scoutPoint">&nbsp;-&nbsp;</span>
        <div class="scout-header-subscript">Path</div>
    </div>
    <div *ngIf="scoutPoint">
        <span [ngStyle]="{ 'color': scoutPoint.color }">{{scoutPoint.name}}&nbsp;&nbsp;{{scoutPoint.exPointId}}</span>
        <div class="scout-header-subscript">Scout Point</div>
    </div>
</div>
